import { HiveMark } from './HiveMark';

/**
 * What the app shows while it is asking the server who you are.
 *
 * Both the auth gate and the login page used to `return null` for the length of
 * that round trip, so every hard refresh -- and every cold visit on a slow
 * connection -- began with a blank white page of indeterminate length. This is
 * less a loading screen than an assurance that something is loading.
 *
 * The mark rather than a spinner: the check usually answers in well under a
 * tenth of a second, and a spinner that appears and disappears inside a couple
 * of frames reads as a flicker. A brand mark that is simply there does not.
 */
export function AppSplash() {
  return (
    <div className="flex min-h-full items-center justify-center px-6 py-16">
      <HiveMark className="h-10 w-10 animate-pulse text-honey-500 motion-reduce:animate-none" />
      <span role="status" className="sr-only">
        Loading Hive
      </span>
    </div>
  );
}
